// @common/components/cta/cta.component.js
import template from './cta.tpl.html';
import modaltemp from './modal.tpl.html';
// import './cta.scss';

// Export CtaController as a named export
export class CtaController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = ["$compile", "AppService", "PageService", "DayjsService", "$sce", "$window", "$timeout", "$scope"];


  constructor($compile, AppService, PageService, DayjsService, $sce, $window, $timeout, $scope) {
    Object.assign(this, { $compile, AppService, PageService, DayjsService, $sce, $window, $timeout, $scope });

    this.progress = 0;
    this.modalRef = null;
    this.myTimeoutPromise = null;
    this.page = undefined;
    this._modalService = null;
    this.modalinc = null;
    this.initModalContainer = this.initModalContainer;
    // Initialized to null to be falsy for ng-if/ng-show
    this.text = null;
    this.link = null;
    this.target = null;
    this.button = {};
  }

  async $onInit() {

    // THIS IS THE CRITICAL AWAIT THAT MUST BE KEPT
    this.page = await this.PageService.getGlobalPage();

    if (this.page && this.page.options) {
      this.button = this.page.options.button || {};
    } else {
      this.$log.warn('CtaController: Page object or options not available. Using default.');
      this.button = {};
    }

    this.text = this.btntext || this.button.text;
    this.link = (this.action || this.button.action || '').toString();
    this.target = this.target || this.button.target;

    this.initModalContainer();
  }

  async optin($e) {
    this.progress = 0;

    if (!this.modalinc) {
      let modalBasePath = this.AppService.config.pubPath;
      this.modalinc = this.$sce.trustAsResourceUrl(`./${modalBasePath}/modals/modal.tpl.html`);
    }

    try {
      const { ModalService } = await import(/* webpackChunkName: "modalService" */ '@common/services/modal.service');
      this._modalService = new ModalService();

      this._modalService.initModal(modaltemp);
      this.$compile(this.modalRef)(this.$scope);
      this.$scope.$applyAsync();

    } catch (error) {
      console.error("CtaController: Error loading or initializing ModalService:", error);
    }
  }

  initModalContainer = () => {
    this.modalRef = document.getElementById('modal');
    if (!this.modalRef) {
      this.modalRef = document.createElement('div');
      this.modalRef.id = "modal";
      this.modalRef.className = "modal fade";
      this.modalRef.tabIndex = -1;
      document.body.appendChild(this.modalRef);
    }
  }


  onClick() {
    const alink = document.createElement('a');
    alink.target = this.target || '_blank';
    alink.href = this.AppService.cta(this.link);
    alink.click();
  }

  scrollTo(target) {
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  }

  $onDestroy() {
    if (this.myTimeoutPromise) {
      this.$timeout.cancel(this.myTimeoutPromise);
    }
    this._modalService?.hideModal?.();
  }
}

export class CtaComponent {
  bindings = {
    btntext: '@?',
    action: '@?',
    target: '@?',
    btnclass: '@?',
    btnarrow: '@?',
    btnalign: '@?'
  };
  template = template;
  controller = CtaController;
}

export default angular
  .module('cta.component', [])
  .component('cta', new CtaComponent())
  .name;